export default {
  namespaced: true,
  state: {
    getCourseFollow: false
  },
  mutations: {
    GET_COURSE_FOLLOW (state, visible) {
      state.getCourseFollow = visible
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/follow.js